import { AI_TOOL_TYPES } from './constants'

export const AI_TOOL_RESULTS_HERO = {
  [AI_TOOL_TYPES.OPPORTUNITY_ENGINE]: {
    eyebrow: 'For Film Professionals',
    title: ['Your Best', '5 Opportunities'],
    subtitle:
      'Ranked matches from open PitchBlu posts — with match scores and exactly how to respond to each.',
    pills: ['Top 5 Matches', 'Match Scores', 'PDF Emailed'],
  },
  [AI_TOOL_TYPES.PRODUCTION_ANALYZER]: {
    eyebrow: 'Production Intelligence',
    title: ['Your Production', 'Analysis Report'],
    subtitle:
      'AI-powered budget ranges, risk assessment, and line-producer insights tailored to your project.',
    pills: ['Budget Range', 'Risk Analysis', 'PDF Emailed'],
  },
  [AI_TOOL_TYPES.BUDGET_BREAKDOWN]: {
    eyebrow: 'Industry Standard ATL / BTL Format',
    title: ['Your Budget', 'Breakdown'],
    subtitle:
      'Investor-ready ATL / BTL breakdown in the format expected by bond companies and distributors.',
    pills: ['ATL / BTL Format', 'Investor Ready', 'PDF Emailed'],
  },
}

export function getAiToolResultsHeroConfig(toolType) {
  return AI_TOOL_RESULTS_HERO[toolType] || null
}
